import React, { useState, useRef } from 'react'
import { Button, Box, CircularProgress, Portal, Text } from '@/components/lib'
import api from '../../api'

export default function FileChooser ({ forObject, forType, content, trigger, accept, fileType, onUploadStart, onUploadFinish, onComplete, onError, asFileInput, multiple = false }) {
  const fileInputRef = useRef(null)
  const [isUploading, setIsUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)

  function startUpload () {
    setIsUploading(true)
    onUploadStart && onUploadStart()
  }

  function finishUpload () {
    setIsUploading(false)
    setUploadProgress(0)
    onUploadFinish && onUploadFinish()
  }

  function chooseFile () {
    fileInputRef?.current?.click()
  }

  function handleFileChosen (e) {
    if (asFileInput) {
      onComplete(e.target.files)
      return
    }

    const apiFunction = fileType === 'video'
      ? api.uploads.generateVideoUploadRequest
      : api.uploads.generateFileUploadRequest
    const files = Array.from(e.target.files || [])
    if (!files.length) return

    startUpload()
    let pending = files.length

    const uploadOne = (file) => {
      apiFunction({
        forType, forId: forObject?._id, name: file.name, size: file.size, type: file.type
      }, (response) => {
        const xhr = new window.XMLHttpRequest()
        xhr.open('PUT', response.signedRequest)
        xhr.setRequestHeader('Content-Type', file.type)
        if (files.length === 1) {
          xhr.upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
              setUploadProgress(parseInt((evt.loaded * 100) / evt.total, 10))
            }
          })
        }
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            pending--
            if (xhr.status === 200) {
              onComplete({
                expectedUrl: response.expectedUrl,
                storedName: response.fileName,
                filePath: response.filePath,
                name: file.name,
                mimeType: file.type,
                size: file.size,
                type: 'file'
              })
            } else if (onError) {
              onError('Unable to upload file')
            }
            if (pending === 0) finishUpload()
          }
        }
        xhr.send(file)
      }, (err) => {
        pending--
        if (onError) onError(err.message || 'Unable to upload file')
        if (pending === 0) finishUpload()
      })
    }

    files.forEach(uploadOne)
  }

  return (
    <>
      <input type='file' style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileChosen} accept={accept || '*'} multiple={multiple} />
      {trigger
        ? React.cloneElement(trigger, { isLoading: isUploading, onClick: chooseFile })
        : <Button size='sm' colorPalette='blue' isLoading={isUploading} onClick={chooseFile}>{content || 'Choose a file'}</Button>}

      {isUploading &&
        <Portal>
          <Box style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999999 }}>
            <Box
              p={3} w='300px' bg='primary.solid' display='flex' alignItems='center'
              rounded='md' shadow='lg'
            >
              <Box h='30px' w='30px' mr={3}>
                <CircularProgress size='30px' value={uploadProgress} />
              </Box>
              <Text color='fg.onAccent'>Uploading...</Text>

            </Box>
          </Box>
        </Portal>}
    </>
  )
}
